import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CalComEmbed, type CalComPrefill } from './CalComEmbed';

interface ResultCalStepProps {
	prefill?: CalComPrefill;
	onNext: () => void;
	onPrev?: () => void;
}

/** Step 3 (non-lt50k path): Book a call with the team. Auto-advances on booking. */
export function ResultCalStep({ prefill, onNext, onPrev }: ResultCalStepProps) {
	const { t } = useTranslation('onboarding');
	const [booked, setBooked] = useState(false);

	const handleBookingConfirmed = useCallback(() => {
		setBooked(true);
		setTimeout(onNext, 1500);
	}, [onNext]);

	return (
		<div className="space-y-6">
			<div className="space-y-2">
				<h2 className="text-foreground text-2xl font-bold tracking-tight">
					{t('resultCal.title')}
				</h2>
				<p className="text-muted-foreground text-sm">
					{t('resultCal.subtitle')}
				</p>
			</div>

			{booked ? (
				<div className="mx-auto flex max-w-md flex-col items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-6 dark:border-emerald-900 dark:bg-emerald-950/20">
					<CheckCircle2 className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
					<p className="text-sm font-medium text-emerald-800 dark:text-emerald-200">
						{t('resultCal.confirmed')}
					</p>
				</div>
			) : (
				<>
					<CalComEmbed prefill={prefill} onBookingConfirmed={handleBookingConfirmed} />
					{onPrev && (
						<div className="mx-auto w-full max-w-md">
							<Button onClick={onPrev} variant="outline" size="lg" className="w-full">
								{t('back')}
							</Button>
						</div>
					)}
				</>
			)}
		</div>
	);
}
